import { AssessmentIcon } from '@assets/icons/Icons'
import { inputsOT } from '@constants/InputsFormOT.constants'
import { IAppStore } from '@models/store.model'
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  TextField,
  Typography
} from '@mui/material'
import { FormContextType, useOTFormContext } from '@pages/OTForm/context/OTForm.context'
import { webApiService } from '@services/index'
import { disableInputsRole } from '@utils/Roles.util'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Supplies } from '../Supplies'

const Diagnostic = () => {
  const { formCtx, saveFormCtx } = useOTFormContext() as FormContextType

  const [data, setData] = useState<{ loading: boolean, listComponent: any[], listFunctionality: any[]}>({ loading: false, listComponent: [], listFunctionality: [] })
  const { enqueueSnackbar } = useSnackbar()
  const userState = useSelector((store: IAppStore) => store.user)
  const [failures, setFailures] = React.useState<string[]>([])

  console.log('🚀 ~ Diagnostic ~ formCtx:', formCtx)

  const loadData = async () => {
    setData({ ...data, loading: true })

    const response : any = await Promise.all([
      webApiService.getAllFailure().then((response) => response.items),
      webApiService.getAllFunctionality().then((res) => res)
    ]).catch((error) => {
      console.log(error)
      enqueueSnackbar(error.message, { variant: 'error' })
    })
    const responseData = await response
    const dataFuncionality = await response[1].data
    setData({ ...data, loading: false, listComponent: disableInputsRole(userState.id_role, formCtx.otInicial.status.id, inputsOT.slDF) ? responseData[0] : responseData[0].filter((item: any) => item.name !== 'Otro'), listFunctionality: dataFuncionality })
    setFailures(formCtx.ot.diagnostic_failures.map(item => String(item.id)))
  }

  const handleChange = (event: SelectChangeEvent<typeof failures>) => {
    const {
      target: { value }
    } = event
    console.log('🚀 ~ handleChange ~ value:', value)
    setFailures(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    )

    // checkeamos si value es array y lo agregamos a saveFormCtx
    if (Array.isArray(value)) {
      // comparamos los arreglos formCtx.ot.diagnostic_failures y value y elimnamos o agregamos segun corresponda

      const diagnosticFailures = value.map((e) => { return { id: Number(e), name: data.listComponent.find((item: any) => String(item.id) === String(e)).name, status: formCtx.ot.diagnostic_failures.some(item => item.id === Number(e)) ? Number(formCtx.ot.diagnostic_failures.find(item => item.id === Number(e))?.status) : 0, id_technician: userState.id, id_request: formCtx.ot.id, technician: userState.name } })
      saveFormCtx({ ...formCtx, ot: { ...formCtx.ot, diagnostic_failures: diagnosticFailures } })
    }

    // saveFormCtx({ ...formCtx, ot: { ...formCtx.ot, diagnostic_failures: typeof value === 'string' ? value.split(',') : value } })
  }

  const changeStatus = (id: number, status: number) => {
    const newDiagnosticFailures = formCtx.ot.diagnostic_failures.map((failure) => {
      if (failure.id === id) {
        return { ...failure, status, id_technician: userState.id }
      }
      return failure
    })
    saveFormCtx({ ...formCtx, ot: { ...formCtx.ot, diagnostic_failures: newDiagnosticFailures } })
  }

  useEffect(() => {
    loadData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='row gy-4'>
      <div className='col-12'>
        <Typography variant='h6' component='div' className='color-title'>
          <AssessmentIcon className='color-azul' /> DIAGNOSTICO
        </Typography>
      </div>
      <div className='col-12 col-lg-6'>
        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>
            Diagnostico
          </InputLabel>
          <Select
            disabled={disableInputsRole(userState.id_role, formCtx.otInicial.status.id, inputsOT.slDiagnostic)}
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={formCtx.ot.diagnostic_information}
            label='Diagnostico'
            onChange={(e) => saveFormCtx({ ...formCtx, ot: { ...formCtx.ot, diagnostic_information: e.target.value } })}
          >
            <MenuItem value=''>Seleccione diagnostico de información</MenuItem>
            <MenuItem value='APLICAR GARANTIA CAMBIO DE EQUIPO' hidden={formCtx.ot.id_flow === 2 || formCtx.ot.id_flow === 4 || formCtx.ot.id_flow === 1 || formCtx.ot.id_flow === 10}>APLICAR GARANTIA CAMBIO DE EQUIPO</MenuItem>
            <MenuItem value='APLICAR GARANTIA REPARAR' hidden={formCtx.ot.id_flow === 2 || formCtx.ot.id_flow === 4 || formCtx.ot.id_flow === 1 || formCtx.ot.id_flow === 10}>APLICAR GARANTIA REPARAR</MenuItem>
            <MenuItem value='NO APLICA GARANTIA MAL USO' hidden={formCtx.ot.id_flow === 2 || formCtx.ot.id_flow === 4 || formCtx.ot.id_flow === 1 || formCtx.ot.id_flow === 10}>NO APLICA GARANTIA MAL USO</MenuItem>
            <MenuItem value='NO APLICA GARANTIA FUNCIONAMIENTO OK' hidden={formCtx.ot.id_flow === 2 || formCtx.ot.id_flow === 4 || formCtx.ot.id_flow === 1 || formCtx.ot.id_flow === 10}>NO APLICA GARANTIA FUNCIONAMIENTO OK</MenuItem>
            <MenuItem value='NO APLICA DEVOLUCIÓN MAL USO' hidden={formCtx.ot.id_flow === 3 || formCtx.ot.id_flow === 4 || formCtx.ot.id_flow === 1 || formCtx.ot.id_flow === 10}>NO APLICA DEVOLUCIÓN MAL USO</MenuItem>
            <MenuItem value='FUNCIONAMIENTO OK' hidden={formCtx.ot.id_flow === 3}>FUNCIONAMIENTO OK</MenuItem>
            <MenuItem value='FUNCIONAMIENTO NO OK' hidden={formCtx.ot.id_flow === 2 || formCtx.ot.id_flow === 3 || formCtx.ot.id_flow === 10}>FUNCIONAMIENTO NO OK</MenuItem>
            <MenuItem value='FUNCIONAMIENTO NO OK, REPARAR' hidden={formCtx.ot.id_flow === 3 || formCtx.ot.id_flow === 4 || formCtx.ot.id_flow === 1}>FUNCIONAMIENTO NO OK, REPARAR</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth className='mt-4'>
          <InputLabel id='label-sl-snd'>
            Funcionalidad del Producto
          </InputLabel>
          <Select
            disabled={disableInputsRole(userState.id_role, formCtx.otInicial.status.id, inputsOT.slScd)}
            labelId='label-sl-snd'
            label='Funcionalidad del Producto'
            id='sl-snd'
            value={formCtx.ot.id_product_functionality === null ? 0 : formCtx.ot.id_product_functionality}
            onChange={(e) => { saveFormCtx({ ...formCtx, ot: { ...formCtx.ot, id_product_functionality: e.target.value.toString() } }) }}
            error={formCtx.ot.diagnostic_information !== '' && (formCtx.ot.id_product_functionality === '')}
          >
            <MenuItem value=''>Seleccione Funcionalidad</MenuItem>
            {
              data.listFunctionality.map(e => {
                return (<MenuItem value={e.id} key={e.id}>{e.name}</MenuItem>)
              })
            }
          </Select>
        </FormControl>
      </div>
      <div className='col-12 col-lg-6'>
        <FormControl fullWidth>
          <TextField
            disabled={disableInputsRole(userState.id_role, formCtx.otInicial.status.id, inputsOT.observacionPpl)}
            type='text'
            name='observacion_principal'
            label='Observación Principal'
            multiline
            rows={5}
            fullWidth
            value={formCtx.ot.technical_service.comments_ppl_failure}
            onChange={(e) => { saveFormCtx({ ...formCtx, ot: { ...formCtx.ot, technical_service: { ...formCtx.ot.technical_service, comments_ppl_failure: e.target.value } } }) }}
          />
        </FormControl>
      </div>

      <div className='col-12'>
        <Typography variant='h6' component='div' className='color-title'>
          <AssessmentIcon className='color-azul' /> FALLAS
        </Typography>
      </div>
      <div className='col-12'>
        <FormControl fullWidth>
          <InputLabel id='demo-multiple-name-label'>Selector fallas</InputLabel>
          <Select
            disabled={disableInputsRole(userState.id_role, formCtx.otInicial.status.id, inputsOT.slDF)}
            labelId='demo-multiple-name-label'
            id='demo-multiple-name'
            multiple
            value={failures}
            onChange={handleChange}
            input={<OutlinedInput label='Selector fallas' />}
          >
            {data.listComponent.map((item) => (
              <MenuItem
                key={item.id}
                value={String(item.id)}
              >
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className='col-12'>
        <div className='mb-2'>
          <span className='small '>Listado Fallas</span>
        </div>
        {
          formCtx.ot.diagnostic_failures.map((failure, idx) => {
            // onClick={() => changeStatus(failure.id )
            return (
              <div key={idx} className='d-flex w-100 gap-3'>
                <div className={failure.status === 1 ? 'd-flex justify-content-between box-failures flex-fill success' : failure.status === 2 ? 'd-flex justify-content-between box-failures flex-fill error' : 'd-flex justify-content-between box-failures flex-fill'}>
                  <span>{failure.name}</span>
                  <span className='badge rounded-pill text-bg-light border fw-light'>T: {failure.technician}</span>
                </div>
                {
                  formCtx.ot.status.id === 25
                    ? (
                      <div className='d-flex'>
                        <Button color='success' onClick={() => changeStatus(failure.id, 1)} size='small'>Reparado</Button>
                        <Button color='error' onClick={() => changeStatus(failure.id, 2)} size='small'>Sin Reparar</Button>
                      </div>
                      )
                    : null
                }

              </div>
            )
          })
        }
      </div>
      {formCtx.loading ? null : <Supplies />}

      <div className='col-12 col-lg-2' hidden={(process.env.REACT_APP_MARKETPLACE_NOTIFICA === undefined ? [] : process.env.REACT_APP_MARKETPLACE_NOTIFICA.split(',').map(e => Number(e))).includes(Number(formCtx.ot.channel.id))}>
        <FormControl className='px-4' hidden={(process.env.REACT_APP_MARKETPLACE_NOTIFICA === undefined ? [] : process.env.REACT_APP_MARKETPLACE_NOTIFICA.split(',').map(e => Number(e))).includes(Number(formCtx.ot.channel.id))}>
          <FormLabel id='chk-notificacion' className='fw-bold'>Envío de correo al cliente</FormLabel>
          <FormControlLabel
            disabled={
              disableInputsRole(userState.id_role, formCtx.otInicial.status.id, inputsOT.chkNotification)
            // || formCtx.ot.listSuppliesTypesValues.some(e => e.buy !== 0)
            // 06/03/2024 se quita esta parte para permitir notificar al cliente aun cuando haya insumos pendientes (caso Francisco Montero)
            }
            control={<Checkbox checked={!!(formCtx.ot.client_notification)} onChange={(e: React.ChangeEvent<HTMLInputElement>) => { saveFormCtx({ ...formCtx, ot: { ...formCtx.ot, client_notification: e.target.checked ? 1 : 0 } }) }} />} label='Si'
          />
        </FormControl>
      </div>

      <div className='col-12 col-lg-4'>
        <FormControl className='px-4'>
          <FormLabel id='demo-radio-buttons-group-label fw-bold'>
            <b>Resolución</b>
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby='demo-radio-buttons-group-label'
            name='radio-buttons-group'
            value={formCtx.ot.diagnostic_resolution}
            onChange={(e) => { saveFormCtx({ ...formCtx, ot: { ...formCtx.ot, diagnostic_resolution: e.target.value } }) }}
          >
            <FormControlLabel
              disabled={
                disableInputsRole(userState.id_role, formCtx.otInicial.status.id, inputsOT.radioReparado, Number(formCtx.ot.channel.id)) ||
                ((formCtx.ot.client_notification === 0 || formCtx.ot.client_notification === null) && !(process.env.REACT_APP_MARKETPLACE_NOTIFICA === undefined ? [] : process.env.REACT_APP_MARKETPLACE_NOTIFICA.split(',').map(e => Number(e))).includes(Number(formCtx.ot.channel.id))) ||
              (formCtx.ot.diagnostic_information !== 'APLICAR GARANTIA CAMBIO DE EQUIPO' && formCtx.ot.diagnostic_information !== 'APLICAR GARANTIA REPARAR' && formCtx.ot.diagnostic_information !== 'FUNCIONAMIENTO NO OK, REPARAR') ||
              formCtx.ot.status.id === 29 ||
              ![25, 15, 16].includes(formCtx.ot.status.id)
              } value='REPARADO' control={<Radio />} label='REPARADO'
            />
            <FormControlLabel
              disabled={
              disableInputsRole(userState.id_role, formCtx.otInicial.status.id, inputsOT.radioSinReparar, Number(formCtx.ot.channel.id)) || // falso
              ((formCtx.ot.client_notification === 0 || formCtx.ot.client_notification === null) && !(process.env.REACT_APP_MARKETPLACE_NOTIFICA === undefined ? [] : process.env.REACT_APP_MARKETPLACE_NOTIFICA.split(',').map(e => Number(e))).includes(Number(formCtx.ot.channel.id))) || // verdadero
              formCtx.ot.status.id === 29 || // falso
              ![25, 15, 16].includes(formCtx.ot.status.id) || // falso
              (formCtx.ot.diagnostic_information === 'APLICAR GARANTIA REPARAR') // falso
} value='SIN REPARACIÓN' control={<Radio />} label='SIN REPARACIÓN'
            />
          </RadioGroup>
        </FormControl>

      </div>

    </div>
  )
}

export default Diagnostic
